import React, {Component} from "react";
import "../../../../css/pages/admin/components/CalendarMonth.css"

class CalendarMonth extends Component {

    NUM_DAYS = 7;

    constructor(props) {
        super(props);
        this.state = props.data;
    }

    render() {
        return (
            <div className="month_wrapper">
                <table className="month_table">
                    <tbody>
                    {
                        this.renderMonthRows()
                    }
                    </tbody>
                </table>
                <h5>{this.state.yearMonth}</h5>
            </div>
        );
    }

    renderMonthRows() {
        let allRows = [];
        let row = [];
        let days = 2 - this.state.startDay;

        let rowsRequired = 1 + Math.ceil((this.state.numDays - (this.NUM_DAYS - this.state.startDay + 1)) / 7);

        // Push day labels
        allRows.push(this.renderDayLabels());

        let active = false;
        let valid = false;
        let bitmap = this.state.bitmap;

        // Push days
        for (let r = 0; r < rowsRequired; r++) {
            row = [];

            for (let c = 1; c <= this.NUM_DAYS; c++) {
                valid = days >= 1 && days <= this.state.numDays;

                if (valid) {
                    active = bitmap & 0x1;
                    bitmap = bitmap >> 1;
                } else {
                    active = false;
                }

                row.push(this.produceTableCellForDate(r, c, days, valid, active));
                days++;
            }

            allRows.push(<tr key={"mnth-" + this.state.yearMonth + "-row-" + r}>{row}</tr>)
        }

        return allRows;
    }

    produceTableCellForDate(r, col, days, valid, active) {
        const isValidKey = valid ? "valid_day" : "";
        const activeKey = active ? " active_day " : " ";
        return (
            <td className={"day_cell " + isValidKey + activeKey}
                key={this.generateDayKey(days)}
                onClick={e => this.toggleDay(days)}>{isValidKey ? days : ""}</td>
        );
    }

    toggleDay(dayNum) {
        // Update bitmap
        let bitIndex = dayNum - 1; // Days are counted from 1
        let res = (0x1 << bitIndex) ^ this.state.bitmap;
        this.props.onDataChange(this.state.yearMonth, res);
    }

    generateDayKey = (days) => {
        return "day-cell-" + this.state.yearMonth + 1 + "-" + days;
    };

    renderDayLabels() {
        return (
            <tr key={"mnth-day-labels"}>
                <td>M</td>
                <td>Tu</td>
                <td>W</td>
                <td>Th</td>
                <td>F</td>
                <td>Sa</td>
                <td>Su</td>
            </tr>
        );
    }

}

export default CalendarMonth;